import React from 'react';

import WidgetComponent from '../../widget/WidgetComponent';
import Widget from '../../widget/Widget';
import Config from '../../config/Config';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';


import '../../css/analysis.css';

class IllegalWarning extends WidgetComponent
{
    constructor(props)
    {
        super(props);

        let url = Config.getHermesPanoramaURL();
        let UID = Config.getHermesPanoramaUID();
        let entname = Widget.getSessionStorage("entname");

        this.state = {

            // 行政处罚
            options:{
                'url':url,
                'records':5,
                'title':'行政处罚'
            },
            columns:[
                {name:'PENDECNO', title:'行政处罚决定书文号', type:'string'},
                {name:'ILLEGACTTYPE', title:'违法行为类型', type:'string'},
                {name:'PENCONTENT', title:'行政处罚内容', type:'string'},
                {name:'PENAUTH', title:'决定机关名称', type:'string'},
                {name:'PENDECISSDATE', title:'处罚决定日期', type:'date'},
                {name:'PUBLICDATE', title:'公示日期', type:'date'},
            ],
            params :{
                'service':'getAdminPenaltyInfo',
                'user':UID,
                'ENTNAME' : entname
            },

            //失信人
            options2:{
                'url':url,
                'records':5,
                'title':'失信人'
            },
            columns2:[
                {name:'CASENO', title:'案号', type:'string'},
                {name:'NAME', title:'被执行人姓名/名称', type:'string'},
                {name:'ENFCCOURT', title:'执行法院', type:'string'},
                {name:'ENFCEVDORG', title:'做出执行依据单位', type:'string'},
                {name:'FILGDATE', title:'立案日期', type:'date'},
                {name:'FULFST', title:'履行情况', type:'string'},
            ],
            params2 :{
                'service':'getCourtDishonestInfo',
                'user':UID,
                'ENTNAME' : entname
            },

            //裁判文书
            options3:{
                'url':url,
                'records':5,
                'title':'裁判文书'
            },
            columns3:[
                {name:'CASETYPE', title:'案件类型', type:'string'},
                {name:'CASENO', title:'案号', type:'string'},
                {name:'TITLE', title:'案件名称', type:'string'},
                {name:'ENFCCOURT', title:'执行法院', type:'string'},
                {name:'JUDGDATE', title:'审判日期', type:'date'},
            ],
            params3 :{
                'service':'getJudgmentInfo',
                'user':UID,
                'ENTNAME' : entname
            },

            //被执行人
            options4:{
                'url':url,
                'records':5,
                'title':'被执行人'
            },
            columns4:[
                {name:'CASENO', title:'案号', type:'string'},
                {name:'ENFCCOURT', title:'执行法院', type:'string'},
                {name:'MONEY', title:'执行标的', type:'string'},
                {name:'FILLINGDATE', title:'立案日期', type:'date'},
                {name:'STATE', title:'状态', type:'string'},
                {name:'ENDDATE', title:'结案日期', type:'date'},
            ],
            params4 :{
                'service':'getCourtExecuteeInfo',
                'user':UID,
                'ENTNAME' : entname
            },

            //经营异常名录
            options5:{
                'url':url,
                'records':5,
                'title':'经营异常名录'
            },
            columns5:[
                {name:'ABNTIME', title:'列入日期', type:'date'},
                {name:'SPECAUSE', title:'列入事由/情形', type:'string'},
                {name:'DECORG', title:'列入做出决定机关', type:'string'},
                {name:'REMDATE', title:'移出日期', type:'date'},
                {name:'REMEXCPRES', title:'移出经营异常名录原因', type:'string'},
                {name:'REDECORG', title:'移出决定机关', type:'date'},
            ],
            params5 :{
                'service':'getAbnormalOperationInfo',
                'user':UID,
                'ENTNAME' : entname
            },
        };

        this.onLoadToken = this.onLoadToken.bind(this);

        Config.getHermesAccess( this.onLoadToken );
    }

    /**
     * 获取 token 回调函数
     * @param {*} result 
     * @returns 
     */
    onLoadToken( result )
    {
        let { params, params2, params3, params4, params5 } = this.state;
        if( result.status===0 )
        {
            params["access"] =  result.result.token;
            params2["access"] =  result.result.token;
            params3["access"] =  result.result.token;
            params4["access"] =  result.result.token;
            params5["access"] =  result.result.token;
   
            this.setState({
                params:params,
                params2:params2,
                params3:params3,
                params4:params4,
                params5:params5,
            }); 
        }
        else
        {
            return ;
        }  
    }

    change( item )
    {
        
        for( let i=0; i<item.target.parentNode.childNodes.length; i++ )
        {
            item.target.parentNode.childNodes[i].className = "title-label";
        }
        item.target.className = 'title-label title-label-active';

        let e = document.getElementById(item.currentTarget.id.substring(1));
        e.scrollIntoView({behavior:'smooth'}); 
    }

    componentDidUpdate( )
    {
        let entname = Widget.getSessionStorage("entname");

        let { params } = this.state;

        if( params.ENTNAME!==entname )
        {
            this.state["params"]["ENTNAME"] = entname;
            this.state["params2"]["ENTNAME"] = entname;
            this.state["params3"]["ENTNAME"] = entname;
            this.state["params4"]["ENTNAME"] = entname;
            this.state["params5"]["ENTNAME"] = entname;
            Config.getHermesAccess( this.onLoadToken );
        }  
    }

    render() 
	{

        const { options, columns, params, options2, columns2, params2, options3, columns3, params3, options4, columns4, params4, options5, columns5, params5 } = this.state;
        
        return(
            <div className="page">
                {/* label */}
                {/* <div className="page-weidu entity-title">
                    <div id="0punish" className="title-label title-label-active" onClick={this.change.bind(this)}>行政处罚</div>
                    <div id="0poorCredit" className="title-label " onClick={this.change.bind(this)}>失信人</div>
                    <div id="0judgmentBook" className="title-label " onClick={this.change.bind(this)}>裁判文书</div>
                    <div id="0person" className="title-label " onClick={this.change.bind(this)}>被执行人</div>
                    <div id="0manageExcList" className="title-label " onClick={this.change.bind(this)}>经营异常名录</div>
                </div> */}

                <div className="page-content page-overflow page-content-custom white padding-20">
                    {/* 行政处罚 */}
                    <div id="punish" className="content-top content-canvas-custom border-top-left-radius-0">
                        <WidgetInterfaceTable options={options} columns={columns} params={params} />
                    </div>

                    {/* 失信人 */}
                    <div id="poorCredit" className="content-top content-canvas-custom">
                        <WidgetInterfaceTable options={options2} columns={columns2} params={params2} />
                    </div>

                    {/* 裁判文书 */}
                    <div id="judgmentBook" className="content-top content-canvas-custom">
                        <WidgetInterfaceTable options={options3} columns={columns3} params={params3} />
                    </div>

                    {/* 被执行人 */}
                    <div id="person" className="content-top content-canvas-custom">
                        <WidgetInterfaceTable options={options4} columns={columns4} params={params4} />
                    </div>

                    {/* 经营异常名录 */}
                    <div id="manageExcList" className="content-top content-canvas-custom">
                        <WidgetInterfaceTable options={options5} columns={columns5} params={params5} />
                    </div>
                </div>
            </div>
        );
    }

}

export default IllegalWarning